import { FC, PropsWithChildren } from 'react';
import { Container, Typography } from '@optimus-web/core';
import { ExpandableBox } from '@optimus-web/helpers';

interface ExpandableLineContentProps {
    expanded: boolean;
}

export const ExpandableLineContent: FC<PropsWithChildren<ExpandableLineContentProps>> = ({ expanded, children }) => (
    <Container padding={['0', '0', '0', '500']}>
        <Typography textStyle="bodySmall" as="div">
            <ExpandableBox expanded={expanded}>{children}</ExpandableBox>
        </Typography>
    </Container>
);
